import { useTranslations } from 'next-intl'
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { popModal } from '@/components/modals'

interface AlertModalProps {
  type?: 'project_size_exceeded'
}

export function AlertModal({ type }: AlertModalProps) {
  const t = useTranslations('alert_modal')

  const title = type ? t(`${type}.title`) : t('title')
  const description = type ? t(`${type}.description`) : null
  const confirmLabel = type ? t(`${type}.confirm`) : t('confirm')

  return (
    <DialogContent className="sm:max-w-[400px] w-full">
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </DialogHeader>
      <div className="mt-6 flex justify-end">
        <Button
          variant="outline_2"
          className="w-full sm:w-auto"
          onClick={() => popModal()}
        >
          {confirmLabel}
        </Button>
      </div>
    </DialogContent>
  )
}
